import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '@app/material/material.module';

import { ButtonModule } from '@shared/components/button/button.module';
import { DataGridModule } from '@shared/components/data-grid/data-grid.module';

import { GeneratePDFDialogComponent } from './generate-pdf-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    DataGridModule,
    MaterialModule
  ],
  declarations: [GeneratePDFDialogComponent],
  exports: [GeneratePDFDialogComponent],
  entryComponents: [GeneratePDFDialogComponent]
})
export class GeneratePDFDialogModule { }
